module.exports = __webpack_public_path__ + "4d4bc4ad2ab31bef2e09a3aaa6324ea6.svg";